<script>
  import { onMount } from 'svelte';

  onMount(async () => {
  });

</script>


<article class="dashboard-wrap">
  <div class="dashboard-box">
      <div class="service-today-status">
          <p class="font-16 font-weight-700">오늘의 서비스 현황</p>
          <section class="service-list mt-3">
              <article class="service-item">
                  <p class="service-item__title">총 생성 문제수</p>
                  <p class="service-item__count total-count">141,372</p>
                  <p class="service-item__info">
                      성공
                      <span>141,120</span>
                  </p>
                  <p class="service-item__info">
                      실패
                      <span>252</span>
                  </p>
              </article>
              <article class="service-item">
                  <p class="service-item__title">생성요청</p>
                  <p class="service-item__count">141,372</p>
                  <p class="service-item__info">
                      성공
                      <span>141,120</span>
                  </p>
                  <p class="service-item__info">
                      실패
                      <span>252</span>
                  </p>
              </article>
              <article class="service-item">
                  <p class="service-item__title">PDF 출력</p>
                  <p class="service-item__count">12,842</p>
                  <p class="service-item__info">
                      성공
                      <span>12,842</span>
                  </p>
                  <p class="service-item__info">
                      실패
                      <span>0</span>
                  </p>
              </article>
              <article class="service-item">
                  <p class="service-item__title">HWP 출력</p>
                  <p class="service-item__count">6,001</p>
                  <p class="service-item__info">
                      성공
                      <span>6,001</span>
                  </p>
                  <p class="service-item__info">
                      실패
                      <span>0</span>
                  </p>
              </article>
          </section>
      </div>
      <div class="service-user-status mt-10">
          <p class="font-16 font-weight-700">서비스 사용자 현황</p>
          <section class="service-list mt-3">
              <article class="service-item" style="border-right:1px solid rgba(var(--color-grey-700))">
                  <p class="service-item__title">총 사용자</p>
                  <p class="service-item__count total-count">9,841</p>
              </article>
              <article class="service-item">
                  <p class="service-item__title">Free</p>
                  <p class="service-item__count">4,102</p>
              </article>
              <article class="service-item">
                  <p class="service-item__title">Standard</p>
                  <p class="service-item__count">3,202</p>
              </article>
              <article class="service-item">
                  <p class="service-item__title">Pro</p>
                  <p class="service-item__count">2,537</p>
              </article>
          </section>
      </div>
  </div>
  <div class="dashboard-box">
      <div class="fail-wrap">
          <p class="font-16 font-weight-700">서비스 이력</p>
          <section class="fail-list mt-3">
              <div class="table-wrap">
                  <table class="table-basic table-basic-dash-fail">
                      <caption>서비스 테이블</caption>
                      <colgroup>
                          <col style="width:18%">
                          <col style="width:25%">
                          <col style="width:auto">
                      </colgroup>
                      <thead>
                          <tr>
                              <th scope="col">진행 상태</th>
                              <th scope="col">등록 일시</th>
                              <th scope="col">내용</th>
                          </tr>
                      </thead>
                      <tbody>
                            <tr>
                                <td>
                                    <button type="button" class="btn btn-error">에러</button>
                                </td>
                                <td>2025-06-17 09:00:00</td>
                                <td><a href="">문제 변환 실패</a></td>
                            </tr>
                            <tr>
                                <td>
                                    <button type="button" class="btn btn-comp">완료</button>
                                </td>
                                <td>2025-06-17 08:00:00</td>
                                <td><a href="">문제 변환 완료</a></td>
                            </tr>
                            <tr>
                                <td><button type="button" class="btn btn-comp">완료</button></td>
                                <td>2025-06-17 07:30:00</td>
                                <td><a href="">PDF 출력 완료</a></td>
                            </tr>
                            <tr>
                                <td><button type="button" class="btn btn-comp">완료</button></td>
                                <td>2025-06-17 06:20:00</td>
                                <td><a href="">HWP 출력 완료</a></td>
                            </tr>
                            <tr>
                                <td><button type="button" class="btn btn-comp">완료</button></td>
                                <td>2025-06-17 05:15:00</td>
                                <td><a href="">PDF 출력 완료</a></td>
                            </tr>
                            <tr>
                                <td><button type="button" class="btn btn-comp">완료</button></td>
                                <td>2025-06-17 04:00:00</td>
                                <td><a href="">HWP 출력 완료</a></td>
                            </tr>
                            <tr>
                                <td><button type="button" class="btn btn btn-error">완료</button></td>
                                <td>2025-06-17 03:45:00</td>
                                <td><a href="">PDF 출력 실패</a></td>
                            </tr>
                            <tr>
                                <td><button type="button" class="btn btn-comp">완료</button></td>
                                <td>2025-06-17 03:20:00</td>
                                <td><a href="">문제 변환 완료</a></td>
                            </tr>
                            <tr>
                                <td><button type="button" class="btn btn-comp">완료</button></td>
                                <td>2025-06-17 02:10:00</td>
                                <td><a href="">문제 변환 완료</a></td>
                            </tr>
                        </tbody>
                  </table>
              </div>
          </section>
      </div>
  </div>
  <div class="dashboard-box">
      <div class="inquiry-wrap">
          <p class="font-16 font-weight-700">1:1문의</p>
          <section class="inquiry-list mt-3">
              <div class="table-wrap">
                  <table class="table-basic table-basic-dash-inquiry">
                      <caption></caption>
                      <colgroup>
                          <col style="width:17%">
                          <col style="width:25%">
                          <col style="width:15%">
                          <col style="width:auto">
                      </colgroup>
                      <thead>
                      <tr>
                          <th scope="col">상태</th>
                          <th scope="col">등록일시</th>
                          <th scope="col">등록자ID</th>
                          <th scope="col">문의제목</th>
                      </tr>
                      </thead>
                      <tbody>
                        <tr>
                            <td><button type="button" class="btn btn-processing">접수중</button></td>
                            <td>2025-06-17 09:23:11</td>
                            <td>minji_k</td>
                            <td><a href="">PDF 출력 속도가 너무 느려요</a></td>
                        </tr>
                        <tr>
                            <td><button type="button" class="btn btn-complete">답변완료</button></td>
                            <td>2025-06-16 15:45:22</td>
                            <td>leejunho</td>
                            <td><a href="">결제 후 플랜이 반영되지 않았습니다</a></td>
                        </tr>
                        <tr>
                            <td><button type="button" class="btn btn-cancel">문의취소</button></td>
                            <td>2025-06-14 08:10:44</td>
                            <td>guest123</td>
                            <td><a href="">계정 삭제 요청</a></td>
                        </tr>
                        <tr>
                            <td><button type="button" class="btn btn-processing">접수중</button></td>
                            <td>2025-06-17 11:15:30</td>
                            <td>seoyoung89</td>
                            <td><a href="">모바일에서 목록이 안보입니다</a></td>
                        </tr>
                        <tr>
                            <td><button type="button" class="btn btn-complete">답변완료</button></td>
                            <td>2025-06-13 14:21:09</td>
                            <td>teacher_park</td>
                            <td><a href="">내가 만든 문제를 다른 선생님과 공유할 수 있나요?</a></td>
                        </tr>
                        <tr>
                            <td><button type="button" class="btn btn-processing">접수중</button></td>
                            <td>2025-06-15 10:05:00</td>
                            <td>test_beta</td>
                            <td><a href="">출제쌤에서 영어 문제도 생성되나요?</a></td>
                        </tr>
                        </tbody>
                  </table>
              </div>
          </section>
      </div>
  </div>
  <div class="dashboard-box">
      <div class="notice-wrap">
          <p class="font-16 font-weight-700">공지사항</p>
          <section class="notice-list mt-3">
              <div class="table-wrap">
                  <table class="table-basic table-basic-dash-notice">
                      <caption></caption>
                      <colgroup>
                          <col style="width:25%">
                          <col style="width:auto">
                          <col style="width:25%">
                      </colgroup>
                      <thead>
                      <tr>
                          <th scope="col">상태</th>
                          <th scope="col">문의제목</th>
                          <th scope="col">등록일시</th>
                      </tr>
                      </thead>
                      <tbody>
                          <tr>
                            <td><button type="button" class="btn btn-processing">공지중</button></td>
                            <td><a href="">[업데이트 안내] HWP 출력 기능 성능 개선</a></td>
                            <td>2025-06-15 10:00:00</td>
                            </tr>
                            <tr>
                            <td><button type="button" class="btn btn-cancel">공지종료</button></td>
                            <td><a href="">[중요] 서버 점검 안내 (6/12)</a></td>
                            <td>2025-06-10 09:30:00</td>
                            </tr>
                            <tr>
                            <td><button type="button" class="btn btn-cancel">공지종료</button></td>
                            <td><a href="">출제쌤 사용 가이드 배포</a></td>
                            <td>2025-06-01 15:45:00</td>
                          </tr>
                      </tbody>
                  </table>
              </div>
          </section>
      </div>
  </div>
</article>